module.exports = __webpack_public_path__ + "assets/images/Sharefe3057369a2252bb2e60cb4a3bc61257.svg";